import { MutableRefObject } from "react";
import { CSSProperties } from "styled-components";
import ErrorHelper from "../ErrorWrapper";

interface SignatureInputProps extends CSSProperties {
  disabled?: boolean;
  canvasRef: MutableRefObject<HTMLCanvasElement | null>;
  w: string;
  h: string;
  label?: string;
  required?: boolean;
  error?: string | boolean;
}

/**
 * @description To Handle the Signature Data while signing Some Document
 *
 * @returns  Signature Input to manage the sign Using CANVAS
 *
 * @link [https://www.npmjs.com/package/signature_pad]
 *
 * @author Rajkumar Rathod
 */
const SignatureInput: React.FC<SignatureInputProps> = ({
  canvasRef,
  w,
  h,
  error,
  label,
  required,
  disabled,
  ...others
}) => (
  <ErrorHelper error={error} label={label} required={required}>
    <div
      id="signatureCanvas"
      style={{
        height: "100%",
        width: "100%",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          borderWidth: 1,
          borderRadius: 5,
          borderColor: error ? "red" : "gray",
          borderStyle: "solid",
          height: "100%",
          width: w,
          ...others,
        }}
        height={h}
        width={w}
      />
    </div>
  </ErrorHelper>
);

export default SignatureInput;
